/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PrepaidBookingDurationTypeDTO = {
    DAY: 'DAY',
    MULTI_DAY: 'MULTI_DAY',
    TIMESLOT: 'TIMESLOT',
    FLEX_PLUS: 'FLEX_PLUS'
} as const;
export type PrepaidBookingDurationTypeDTO = typeof PrepaidBookingDurationTypeDTO[keyof typeof PrepaidBookingDurationTypeDTO];

